// English for the settings area. Key: exact Macedonian text passed to t().
const en = {
  // --- Navigation (navConfig.js names / descriptions / headerTitle) ---
  'Почетна': 'Home',
  'Финансии': 'Finance',
  'Фактури': 'Invoices',
  'Преглед на сите фактури.': 'View all invoices.',
  'Нова фактура': 'New invoice',
  'Креирај нова фактура.': 'Create a new invoice.',
  'Нова': 'New',
  'Испратници': 'Delivery notes',
  'Преглед на испратници.': 'View delivery notes.',
  'Плаќања': 'Payments',
  'Преглед на примени плаќања.': 'View received payments.',
  'Продукти': 'Products',
  'Сите продукти': 'All products',
  'Преглед на сите производи.': 'View all products.',
  'Импорт': 'Import',
  'Увези производи од датотека.': 'Import products from a file.',
  'Категории': 'Categories',
  'Преглед и уредување на категории.': 'View and edit categories.',
  'Производители': 'Manufacturers',
  'Преглед на производители.': 'View manufacturers.',
  'Магацин': 'Warehouse',
  'Состојба и залихи во магацинот.': 'Warehouse status and stock.',
  'Партнери': 'Partners',
  'Подесувања': 'Settings',

  // --- Sidebar menu ---
  'Почетна страна': 'Home page',
  'Лого': 'Logo',
  'овозможено од PulseFinance': 'powered by PulseFinance',
  'Затвори мени': 'Close menu',
  'Собери мени': 'Collapse menu',
  'Прошири мени': 'Expand menu',

  // --- Settings page / My business ---
  'Податоци за бизнисот': 'Business details',
  'Внесете ги податоците.': 'Enter your details.',
  'Неуспешно вчитување на поставките за бизнисот': 'Failed to load business settings',
  'Неуспешно зачувување на поставките за бизнисот': 'Failed to save business settings',
  'Поставките за бизнисот се успешно зачувани': 'Business settings saved successfully',
  'Неуспешно вчитување на корисниците': 'Failed to load users',
  'Неуспешно зачувување на корисниците': 'Failed to save users',
  'Корисниците се успешно зачувани': 'Users saved successfully',
  'Неуспешно прикачување на логото': 'Failed to upload the logo',
  'Логото е успешно прикачено': 'Logo uploaded successfully',
  'Грешка!': 'Error!',
  'Успешно!': 'Success!',
  'Подесувања за фактурирање': 'Invoicing settings',
  'Корисници': 'Users',
  'Име на бизнисот': 'Business name',
  'Име': 'Name',
  'Прикачи лого': 'Upload logo',
  'Адреса': 'Address',
  'Град': 'City',
  'Поштенски број': 'Postal code',
  'Држава': 'Country',
  'Телефон': 'Phone',
  'Е-пошта': 'Email',
  'Веб-страница': 'Website',
  'Кратко име (slug)': 'Short name (slug)',
  'Податоци за регистрација': 'Registration details',
  'ЕДБ / ДДВ број': 'Tax ID / VAT number',
  'ЕМБС': 'Company registration number',
  'Банкарски податоци': 'Bank details',
  'Име на банка': 'Bank name',
  'Жиро сметка': 'Bank account',
  'SWIFT / BIC код': 'SWIFT / BIC code',
  'Подесувања за фактури': 'Invoice settings',
  'Валута': 'Currency',
  'Валута (пр. MKD, EUR, USD)': 'Currency (e.g. MKD, EUR, USD)',
  'Стандардна стапка на ДДВ (%)': 'Default VAT rate (%)',
  'Стапка на ДДВ (пр. 18.00)': 'VAT rate (e.g. 18.00)',
  'Префикс на број на фактура': 'Invoice number prefix',
  'Префикс на фактура (пр. INV-)': 'Invoice prefix (e.g. INV-)',
  'Стандарден рок за плаќање (денови)': 'Default payment term (days)',
  'Рок за плаќање во денови (пр. 15)': 'Payment term in days (e.g. 15)',
  'Стандардни забелешки на фактура': 'Default invoice notes',
  'Забелешки што ќе се прикажуваат на фактурите': 'Notes shown on invoices',
  'Улога': 'Role',
  'Акции': 'Actions',
  'вработен': 'employee',
  'администратор': 'administrator',
  'Администраторот не може да се избрише': 'The administrator cannot be deleted',
  'Отстрани': 'Remove',
  'Додади корисник': 'Add user',
  'Зачувување...': 'Saving...',
  'Зачувај корисници': 'Save users',
  'Зачувај подесувања': 'Save settings',

  // --- Warehouse list ---
  'Неуспешно вчитување на залихите': 'Failed to load stock',
  'Критично': 'Critical',
  'Ниско': 'Low',
  'Добро': 'Good',
  'Вчитување залихи...': 'Loading stock...',
  'Залихи во магацин': 'Warehouse stock',
  'Преглед и управување со залихите во магацинот': 'View and manage warehouse stock',
  'Ново движење': 'New movement',
  '← Назад кон производи': '← Back to products',
  'Пребарај по назив, SKU или локација...': 'Search by name, SKU or location...',
  'Вкупно ставки': 'Total items',
  'Вкупна залиха': 'Total stock',
  'Напомена: прикажани се примерни податоци - {error}': 'Note: showing sample data - {error}',
  'Производ': 'Product',
  'Локација': 'Location',
  'Тековна залиха': 'Current stock',
  'Резервирано': 'Reserved',
  'Достапно': 'Available',
  'Последно движење': 'Last movement',
  'Нема пронајдени залихи': 'No stock found',
  'Обидете се со други поими за пребарување.': 'Try different search terms.',
  'Залихите ќе се прикажат тука.': 'Stock will appear here.',

  // --- Warehouse movement ---
  'Потребна е барем една ставка со производ, количина и единица': 'At least one item with a product, quantity and unit is required',
  'Движењето {number} е успешно креирано!': 'Movement {number} created successfully!',
  'Неуспешно креирање на движење': 'Failed to create the movement',
  'Влез': 'Stock in',
  'Додади залиха во магацинот': 'Add stock to the warehouse',
  'Излез': 'Stock out',
  'Извади залиха од магацинот': 'Remove stock from the warehouse',
  'Пренос': 'Transfer',
  'Премести меѓу локации': 'Move between locations',
  'Ново движење во магацин': 'New stock movement',
  'Додајте, извадете или пренесете залиха за повеќе производи': 'Add, remove or transfer stock for multiple products',
  '← Назад кон магацин': '← Back to warehouse',
  'Тип на движење': 'Movement type',
  'Датум на движење *': 'Movement date *',
  'Од локација *': 'From location *',
  'Изберете локација': 'Select a location',
  'До локација *': 'To location *',
  'Локација *': 'Location *',
  'Референца': 'Reference',
  'Бр. на фактура, нарачка и сл.': 'Invoice no., order no., etc.',
  'Ставки': 'Items',
  'Додади ставка': 'Add item',
  'Дуплирај ставка': 'Duplicate item',
  'Отстрани ставка': 'Remove item',
  'Производ *': 'Product *',
  'Изберете производ': 'Select a product',
  'Количина *': 'Quantity *',
  'ед.': 'unit',
  'Единечна набавна цена': 'Unit cost',
  'Вкупна цена': 'Total price',
  'Општи забелешки': 'General notes',
  'Општи забелешки за ова движење...': 'General notes for this movement...',
  'Се креира...': 'Creating...',
  'Креирај движење ({count} ставки)': 'Create movement ({count} items)',

  // --- Orders ---
  'Нарачки': 'Orders',
  'Број на нарачка': 'Order number',
  'Датум на нарачка': 'Order date',
  'Купувач': 'Customer',
  'Креирано': 'Created',
  'Филтрирај по број, купувач или статус': 'Filter by number, customer or status',
  'Избери колони': 'Choose columns',
  'Освежи': 'Refresh',
  'Извези': 'Export',
  'Нема пронајдени нарачки.': 'No orders found.',
  'Изберете производ за сите ставки': 'Select a product for every item',
  'Нарачката е успешно зачувана!': 'Order saved successfully!',
  'Нова нарачка': 'New order',
  'Назив на производ': 'Product name',
  'Коментар': 'Comment',
  'Изберете производ...': 'Select a product...',
  'Коментар (опционално)...': 'Comment (optional)...',
  'Последната ставка не може да се избрише': 'The last item cannot be deleted',
  'Избриши ставка': 'Delete item',
  'Додади ред': 'Add row',
  'Зачувај нарачка': 'Save order',

  // --- PDF / invoice preview ---
  'Преглед на PDF: {filename}': 'PDF preview: {filename}',
  'Тип на документ: {documentType} | Број: {documentNumber}': 'Document type: {documentType} | Number: {documentNumber}',
  'PDF не е достапен': 'PDF not available',
  'Ова е привремен приказ. Вистинскиот PDF ќе се прикаже тука откако ќе биде генериран и зачуван на серверот.': 'This is a temporary view. The actual PDF will appear here once it has been generated and saved on the server.',
  'Очекувани функции:': 'Planned features:',
  '• Целосен приказ на PDF во прелистувачот': '• Full PDF view in the browser',
  '• Преземање': '• Download',
  '• Печатење': '• Printing',
  '• Прилагоден приказ на мобилни уреди': '• Mobile-friendly view',
  '• Пристап преку QR код': '• Access via QR code',
  '✅ Структурата на URL работи': '✅ URL structure works',
  'Структурата на URL за преглед е правилно имплементирана и достапна преку QR кодови.': 'The preview URL structure is implemented correctly and reachable via QR codes.',
  '⏳ Интеграција за складирање PDF': '⏳ PDF storage integration',
  'Серверските крајни точки за PDF се креирани и подготвени за интеграција.': 'The server PDF endpoints are created and ready for integration.',
  'Неуспешно вчитување на PDF': 'Failed to load the PDF',
  'Вчитување PDF...': 'Loading PDF...',
  'Преглед на PDF': 'PDF preview',
  'Нема PDF за прикажување': 'No PDF to display',
  'Ве молиме најавете се за да ја видите фактурата.': 'Please log in to view the invoice.',
  'Неуспешно вчитување на фактурата: {status} {statusText}': 'Failed to load the invoice: {status} {statusText}',
  'Неуспешно вчитување на фактурата': 'Failed to load the invoice',
  'Вчитување на фактурата...': 'Loading invoice...',
  'Прегледот не е достапен': 'Preview not available',
  'Фактурата не е пронајдена': 'Invoice not found',
  'Печати': 'Print',
  'QR код': 'QR code',

  // --- Login ---
  'Погрешна е-пошта или лозинка': 'Incorrect email or password',
  'Лого на апликацијата': 'App logo',
  'Добредојдовте назад': 'Welcome back',
  'Лозинка': 'Password',
  'Најави се': 'Log in',

  // --- Shared filters / drawer ---
  'Период': 'Period',
  'Сите датуми': 'All dates',
  'Денес': 'Today',
  'Вчера': 'Yesterday',
  'Последни 7 дена': 'Last 7 days',
  'Последен месец': 'Last month',
  'Прилагоден': 'Custom',
  'Од датум': 'From date',
  'До датум': 'To date',
  'Филтери': 'Filters',
  'Затвори': 'Close',
};

export default en;
